<template>
  <div id="zhyss">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'zhyss'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/exhibitors/zhyss/Zhyss.vue